import angular from 'angular';

angular.module('app.services')

    .factory('LoginService', ['$q', 'LoginFactory', function($q, LoginFactory) {
        var service = {};

        service.authenticateUser = function() {

        };
    }])

    .factory('LoginFactory', function($resource, AppConfig) {
        var factory = {};
        var accessToken = "h238475nco4857anoc9ow475no9ca";

        factory.authenticate = function() {
            return $resource(AppConfig.IO_API_URL + 'login')
        };

    });
